export default __webpack_public_path__ + "static/media/1697.97c96fd4.png";